(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features--feature-card"] && !window.DesignMode) return;
  try {
    
  (function() {
    const rolling = () => {
      const elements = document.querySelectorAll('.scrollable-features-grid');  

      if (elements.length === 0) return;

      elements.forEach(element => {
        const items = element.querySelectorAll('.scrollable-features-grid-item'); 

        items.forEach(item => {
          const width = item.querySelector('h3').clientWidth;  
          item.removeAttribute('style'); 
          item.style.width = width + 100 + parseInt(window.getComputedStyle(item).paddingLeft) + 'px';
        });
      });
    };

    rolling();

    //
    let resizer = null;

    window.addEventListener('resize', () => {
      if (resizer !== null) clearTimeout(resizer);

      resizer = setTimeout(() => {
        rolling();
      }, 66);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--product"]) return;
  try {
     
(function() {  
    //
    document.body.classList.add('content-loaded'); 

    //
	var buttons = document.querySelectorAll('.js-modal-btn');
	
	if (buttons.length !== 0) {
		[].forEach.call(buttons, function(button) {
			button.addEventListener('click', function(e) {
				document.querySelector('.' + button.dataset.modal ).classList.toggle('show');
			});
		});
	}

	//
	var closeButtons = document.querySelectorAll('.c-modal-close');
	
	if (closeButtons.length !== 0) {
		[].forEach.call(closeButtons, function(closeButton) {
			closeButton.addEventListener('click', function(e) {
				closeButton.closest('.c-modal').classList.toggle('show');
			});
		});
	}

    //
    window.addEventListener('load', () => {
      setTimeout(() => {
        //
    document.body.classList.add('oke-sr-reivews-loaded'); 
      const inlineReview = document.querySelector('.oke-sr-count .oke-sr-count-number');
        if (inlineReview) {
      const reviewCount = inlineReview.innerText;
      const reviewTotal = 2000 + parseInt(reviewCount); //700
    inlineReview.innerText = reviewTotal;

      const basedReviews = document.querySelector('.oke-w-ratingAverageModule-count');
      basedReviews.innerText = 'Based on '+ reviewTotal +' reviews';

      const totalReviews = document.querySelector('.oke-w-reviews-count');
      totalReviews.innerText = ''+ reviewTotal +' reviews';
        } 
    }, 1000);
    });
  
	//
	var summary = document.querySelector('.product-summary');
	
	if (summary) {
      var url = window.location.pathname;

      var links = document.querySelectorAll('.products-btn-wrap .btn');

      if (links.length !== 0) {
         [].forEach.call(links, function(link) {
            var href = link.pathname;
            if (url === href) {
              link.classList.add('is-current');
            }
        });
      }

      var element = document.getElementById('okendo-product-summary-review') ? document.getElementById('okendo-product-summary-review') : document.querySelector('.product-description-header');
      element.after(summary);
	}


	//
	var pricePrefix = document.getElementById('js-price-prefix');
	var priceSuffix = document.getElementById('js-price-suffix');

	if (pricePrefix) {
		var priceField = document.querySelector('#price-field .money');
        if (priceField !== null) {
              priceField.before(pricePrefix);
              priceSuffix.classList.remove('d-none');
        }
	}
	
	if (priceSuffix) {
		var priceField = document.querySelector('#price-field .money');
        if (priceField !== null) {
    		priceField.after(priceSuffix);
    		priceSuffix.classList.remove('d-none');
        }
	}



	// Increment / Decrement price
	var moneyField = document.querySelector('#price-field .money');
	var priceField = document.getElementById('quantity');
	var price = moneyField !== null ? moneyField.innerText.replace(/[^0-9.]/g, '') : '';

	var plusBtn = document.querySelector('.qty-plus');
	var minusBtn = document.querySelector('.qty-minus');

	plusBtn.addEventListener('click', function(e) {
        if (document.getElementById('rc-radio1') !== null && document.getElementById('rc-radio1').checked) price = document.querySelector('.subscription-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
        if (document.getElementById('rc-radio2') !== null && document.getElementById('rc-radio2').checked) price = document.querySelector('.onetime-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
		setTimeout(function() {
            if (moneyField) {
              moneyField.innerText = '$' + (price * priceField.value).toFixed(2);
              const afterPayPrice = document.querySelector('afterpay-placement').shadowRoot.querySelector('.afterpay-main-text strong');
              afterPayPrice.innerText = '$' + ((price * priceField.value) / 4).toFixed(2);
            }
		});
	});

  	minusBtn.addEventListener('click', function(e) {
        if (document.getElementById('rc-radio1') !== null && document.getElementById('rc-radio1').checked) price = document.querySelector('.subscription-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
        if (document.getElementById('rc-radio2') !== null && document.getElementById('rc-radio2').checked) price = document.querySelector('.onetime-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
		setTimeout(function() {
          if (moneyField) {
    		  moneyField.innerText = '$' + (price * priceField.value).toFixed(2);
              const afterPayPrice = document.querySelector('afterpay-placement').shadowRoot.querySelector('.afterpay-main-text strong');
              afterPayPrice.innerText = '$' + ((price * priceField.value) / 4).toFixed(2);
          }
		});
	});

	priceField.addEventListener('input', function(e) {
        if (document.getElementById('rc-radio1') !== null && document.getElementById('rc-radio1').checked) price = document.querySelector('.subscription-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
        if (document.getElementById('rc-radio2') !== null && document.getElementById('rc-radio2').checked) price = document.querySelector('.onetime-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
		setTimeout(function() {
            if (e.target.value === '0') e.target.value = 1;
          if (moneyField) {
			moneyField.innerText = '$' + (price * e.target.value).toFixed(2);
            const afterPayPrice = document.querySelector('afterpay-placement').shadowRoot.querySelector('.afterpay-main-text strong');
            afterPayPrice.innerText = '$' + ((price * priceField.value) / 4).toFixed(2);
          }
		});
	});

    priceField.addEventListener('blur', function(e) {
        if (document.getElementById('rc-radio1') !== null && document.getElementById('rc-radio1').checked) price = document.querySelector('.subscription-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
        if (document.getElementById('rc-radio2') !== null && document.getElementById('rc-radio2').checked) price = document.querySelector('.onetime-radio  .price-label').innerText.replace(/[^0-9.]/g, '');
  		setTimeout(function() {
            if (e.target.value === '' || e.target.value === 'NaN') e.target.value = 1;
          if (moneyField) {
  			moneyField.innerText = '$' + (price * e.target.value).toFixed(2);
            const afterPayPrice = document.querySelector('afterpay-placement').shadowRoot.querySelector('.afterpay-main-text strong');
            afterPayPrice.innerText = '$' + ((price * priceField.value) / 4).toFixed(2);
          }
  		});
  	});


    //
    window.addEventListener('load', function(e) {
      // PDP changes
      document.body.classList.add('page-loaded');
  
      const pdpProduct = document.querySelector('.pdp-product');

      if (pdpProduct) {
        const oneTimeSubscription = document.getElementById('rc-radio1');

        if (oneTimeSubscription) {
          oneTimeSubscription.checked = false;
        }

        const SubscribeSubscription = document.getElementById('rc-radio2');

        if (SubscribeSubscription) {
          SubscribeSubscription.checked = false;
        }

        const pdpButton = document.getElementById('pdp-product-reserved-button');

        if (pdpButton) {
          pdpButton.addEventListener('click', e => {
            e.preventDefault();
            const el = e.currentTarget;
            el.classList.add('is-active');
            pdpProduct.classList.add('is-selected');

            if (oneTimeSubscription) {
              oneTimeSubscription.checked = true;
            }
          });
        }
      }

      //
      setTimeout(function() {
            // PDP changes
            // const oneTimeDiscountLabel = document.querySelector('.onetime-radio .discount-label');

            // if (oneTimeDiscountLabel) {
            //   oneTimeDiscountLabel.innerHTML = oneTimeDiscountLabel.innerHTML.replace(/&amp;/g, '&');
            //   console.log(oneTimeDiscountLabel.innerText)
            // }
        
            //
            const countryCode = document.getElementById('country_code').value;
        
            // Afterpay layout adjustment
            const priceNode = document.getElementById('price-field');
            if (priceNode === null) return;
            const afterPay = document.querySelector('afterpay-placement');
            priceNode.appendChild(afterPay);

            const div = document.createElement('div');
            div.id = 'afterPayWrapper';
            div.appendChild(afterPay);
            priceNode.appendChild(div);

            //
            const afterPayWrapper = document.getElementById('afterPayWrapper');
            const afterPayPrice = document.querySelector('afterpay-placement').shadowRoot.querySelector('.afterpay-main-text strong');
        
            //subsave
            const subsave = document.querySelector('#rc-radio1');
            
            if (subsave !== null) {
              const subsavePriceNode = document.querySelector('.subscription-radio .price-label');
              
              if (subsave.checked) {
                moneyField.innerText = subsavePriceNode.innerText;
                price = moneyField.innerText.replace(/[^0-9.]/g, '');
                priceSuffix.innerText = (countryCode === 'US') ? ' ($1.83/bowl)' : ' ($2.96/bowl)';
                //afterPayWrapper.style.display = 'none'; 
                afterPayPrice.innerText = '$' + ((price * priceField.value) / 4).toFixed(2);
              }

              subsave.addEventListener('change', function(e) {
                const el = e.target;
  
                if (e.target.checked) {
                  const currency = subsavePriceNode.innerText.charAt(0);
                  moneyField.innerText = currency + (subsavePriceNode.innerText.replace(/[^0-9.]/g, '') * priceField.value).toFixed(2);
                  price = moneyField.innerText.replace(/[^0-9.]/g, '');
                  priceSuffix.innerText = (countryCode === 'US') ? ' ($1.83/bowl)' : ' ($2.96/bowl)';
                  //afterPayWrapper.style.display = 'none';
                  afterPayPrice.innerText = '$' + ((price) / 4).toFixed(2);
                }
              });
            }

            //onetime            
            const onetime = document.querySelector('#rc-radio2');
            
            if (onetime !== null) {
              const onetimePriceNode = document.querySelector('.onetime-radio .price-label');

              if (onetime.checked) {
                moneyField.innerText = onetimePriceNode.innerText;
                price = moneyField.innerText.replace(/[^0-9.]/g, '');
                priceSuffix.innerText = (countryCode === 'US') ? ' ($2.45/BOWL)' : ' ($3.95/bowl)';
                //afterPayWrapper.style.display = 'block';
                afterPayPrice.innerText = '$' + ((price * priceField.value) / 4).toFixed(2);
              }


              onetime.addEventListener('change', function(e) {
                const el = e.target;
  
                if (e.target.checked) {
                  const currency = onetimePriceNode.innerText.charAt(0);
                  moneyField.innerText = currency + (onetimePriceNode.innerText.replace(/[^0-9.]/g, '') * priceField.value).toFixed(2);
                  price = moneyField.innerText.replace(/[^0-9.]/g, '');
                  priceSuffix.innerText = (countryCode === 'US') ? ' ($2.45/BOWL)' : ' ($3.95/bowl)';
                  //afterPayWrapper.style.display = 'block';
                  afterPayPrice.innerText = '$' + ((price) / 4).toFixed(2);
                }
              });
            }
		}, 1200);
    });
})();

  } catch(e) { console.error(e); }
})();
})();
